import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  setSnackbarData,
  setSnackbarOpen
} from "../../../snackbar/redux/snackbarSlice";
import { FormattedMessage, injectIntl } from "react-intl";

import { _getUserInfo, _logout, _resendEmailVerification } from "../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { setBackdropOpen } from "../../../../redux/slices/backdropSlice";
import { setLoggedIn } from "../../../../redux/slices/loggedIn";
import {
  logoutUser,
  setUser
} from "../../../../modules/user/redux/slices/userDataSlice";
// icons
import { ReactComponent as EmailIcon } from "../../../../assets/icons/imported/email-verification.svg";

function EmailVerificationRequired() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const userData = useSelector((state) => state.userData.value)
  const theme = useSelector((state) => state.theme.value)
  const isLoggedIn = useSelector((state) => state.userData.value.email)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 480)

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth
      setIsMobile(width <= 768)
      setIsSmallMobile(width <= 480)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login")
    }
  }, [])

  const logout = () => {
    _logout(
      () => {
        dispatch(logoutUser())
        dispatch(setLoggedIn(false))
        dispatch(setUser(""))
        dispatch(setBackdropOpen(false))
        navigate("/login")
      },
      (error) => {
        dispatch(logoutUser())
        dispatch(setLoggedIn(false))
        dispatch(setUser(""))
        dispatch(setBackdropOpen(false))
        // console.log(error)
      }
    )
  }

  const handleVerificationResend = () => {
    _resendEmailVerification(
      {
        email: userData?.email
      },

      () => {
        // console.log("sent")
        dispatch(
          setSnackbarData({
            alertMessage: "Email successfully sent",
            callback: () => { },
            actionType: "close", // link - close
            severity: "success",
            position: "topRight"
          })
        )
        dispatch(setSnackbarOpen(true))
        logout()
      },
      (error) => {
        dispatch(setSnackbarOpen(true))
        dispatch(
          setSnackbarData({
            alertMessage: error.errors[0].length ? (
              <FormattedMessage id={error.errors[0]} />
            ) : (
              "Unknown Error"
            ),
            severity: "error",
            //buttonMessage: 'See order',
            callback: () => { },
            //actionType: 'link', // link - close
            //linkTo: '/account/orders/open',
            position: "topRight"
          })
        )
      }
    )
  }

  return (
    <div style={{ width: '100%' }}>
      {/* Mobile Logo/Branding */}
      {isMobile && (
        <div style={{
          textAlign: 'center',
          marginBottom: isSmallMobile ? '30px' : '40px',
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: isSmallMobile ? '8px' : '12px',
            marginBottom: isSmallMobile ? '20px' : '25px',
          }}>
            <img
              src="/logo-small-white.svg"
              alt="Logo"
              width={isSmallMobile ? "28" : "35"}
              height={isSmallMobile ? "28" : "35"}
              style={{ objectFit: 'contain' }}
            />
            <span style={{
              fontSize: isSmallMobile ? '24px' : '28px',
              fontWeight: 700,
              color: 'var(--text-color, white)',
            }}>WealthTech</span>
          </div>
          <p style={{
            color: 'var(--text-secondary, #94a3b8)',
            fontSize: isSmallMobile ? '14px' : '16px',
            lineHeight: 1.5,
            margin: 0,
          }}>
            We've sent a verification link to your email address.
          </p>
        </div>
      )}

      <div style={{ marginBottom: isSmallMobile ? '20px' : isMobile ? '25px' : '30px' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: isSmallMobile ? '15px' : '20px',
        }}>
          <EmailIcon width={isSmallMobile ? 60 : isMobile ? 70 : 80} />
        </div>
        <h2 style={{
          fontSize: isSmallMobile ? '24px' : isMobile ? '26px' : '32px',
          color: theme === 'light' ? '#111827' : 'var(--text-color, white)',
          marginBottom: '10px',
          textAlign: 'center',
        }}>Email Verification Required</h2>
        <div style={{
          color: 'var(--text-secondary, #94a3b8)',
          fontSize: isSmallMobile ? '13px' : isMobile ? '14px' : '16px',
          textAlign: 'center',
          lineHeight: 1.5,
        }}>
          <p style={{ margin: '0 0 10px 0' }}>
            Before you can sign in, please verify your email address.
          </p>
          <p style={{ margin: '0 0 10px 0' }}>
            We have sent a verification link to your email
          </p>
          <p style={{ margin: '0' }}>
            Once verified, you can sign in to access your account.
          </p>
        </div>
      </div>

      <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isSmallMobile ? '12px' : '15px',
        justifyContent: 'center',
        marginBottom: isSmallMobile ? '20px' : '25px',
      }}>
        <button
          onClick={handleVerificationResend}
          style={{
            padding: isSmallMobile ? '12px 20px' : '14px 24px',
            background: 'transparent',
            border: '2px solid #009999',
            borderRadius: '10px',
            color: '#009999',
            fontSize: isSmallMobile ? '14px' : '15px',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            minWidth: isMobile ? '100%' : '140px',
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#009999'
            e.target.style.color = 'white'
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'transparent'
            e.target.style.color = '#009999'
          }}
        >
          Resend verification
        </button>
        <button
          onClick={(e) => {
            _getUserInfo(
              (data) => {
                dispatch(setUser(data))
                if (data.errors) {
                  dispatch(logoutUser())
                }
              },
              (error) => {
                if (error.errors) {
                  dispatch(logoutUser())
                }
              }
            )
            navigate("/")
          }}
          style={{
            padding: isSmallMobile ? '12px 20px' : '14px 24px',
            background: 'linear-gradient(135deg, #009999 0%, #007a7a 100%)',
            border: 'none',
            borderRadius: '10px',
            color: 'white',
            fontSize: isSmallMobile ? '14px' : '15px',
            fontWeight: 600,
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(0, 153, 153, 0.3)',
            minWidth: isMobile ? '100%' : '140px',
          }}
        >
          Home
        </button>
      </div>

      <div style={{
        textAlign: 'center',
        color: 'var(--text-secondary, #94a3b8)',
        fontSize: isSmallMobile ? '13px' : isMobile ? '14px' : '15px',
      }}>
        Wrong email?{' '}
        <button
          onClick={() => navigate('/login')}
          style={{
            background: 'none',
            border: 'none',
            color: '#009999',
            textDecoration: 'none',
            fontWeight: 600,
            cursor: 'pointer',
            fontSize: isSmallMobile ? '13px' : isMobile ? '14px' : '15px',
          }}
        >
          Go back to Sign In
        </button>
      </div>
    </div>
  )
}

export default injectIntl(EmailVerificationRequired)
